import { NODES_BASE_LENGTH,BaseNode, FoblexNode } from './base-node';

export class DependentNode {
    variant = FoblexNode.Variant.Dependent;
    type: string;
    id: number;
    dimension: FoblexNode.Dimension;
    baseNode: BaseNode;
    place: FoblexNode.Place;
    position: FoblexNode.Position;

    constructor(
        id: number,
        type: string,
        dimension: FoblexNode.Dimension,
        baseNode: BaseNode,
        place: FoblexNode.Place
    ) {
        this.id = id;
        this.dimension = dimension;
        this.baseNode = baseNode;
        this.place = place;
        this.type = type;

        // Initialize position
        this.position = this.calculatePosition();
    }

    private calculatePosition(): FoblexNode.Position {
        const { baseNode, dimension, place } = this;
        const gap = 25;
        const connectorWidth = 25;

        switch (place) {
            case FoblexNode.Place.Top:
                return {
                    x: baseNode.position.x + ((baseNode.dimension.width * NODES_BASE_LENGTH) + (2 * connectorWidth) - (dimension.width * NODES_BASE_LENGTH)) / 2,
                    y: baseNode.position.y - dimension.height * NODES_BASE_LENGTH - gap,
                };
            case FoblexNode.Place.Bottom:
                return {
                    x: baseNode.position.x + ((baseNode.dimension.width * NODES_BASE_LENGTH) + (2 * connectorWidth) - (dimension.width * NODES_BASE_LENGTH)) / 2,
                    y: baseNode.position.y + baseNode.dimension.height * NODES_BASE_LENGTH + gap,
                };
            case FoblexNode.Place.Left:
                return {
                    x: baseNode.position.x - dimension.width * NODES_BASE_LENGTH - gap,
                    y: baseNode.position.y + (baseNode.dimension.height * NODES_BASE_LENGTH - dimension.height * NODES_BASE_LENGTH) / 2,
                };
            case FoblexNode.Place.Right:
                return {
                    x: baseNode.position.x + (baseNode.dimension.width * NODES_BASE_LENGTH) + (2 * connectorWidth) + gap,
                    y: baseNode.position.y + (baseNode.dimension.height * NODES_BASE_LENGTH - dimension.height * NODES_BASE_LENGTH) / 2,
                };
            case FoblexNode.Place.TopLeft:
                return {
                    x: baseNode.position.x - dimension.width * NODES_BASE_LENGTH - gap,
                    y: baseNode.position.y - dimension.height * NODES_BASE_LENGTH - gap,
                };
            case FoblexNode.Place.TopRight:
                return {
                    x: baseNode.position.x + (baseNode.dimension.width * NODES_BASE_LENGTH) + (2 * connectorWidth) + gap,
                    y: baseNode.position.y - dimension.height * NODES_BASE_LENGTH - gap,
                };
            case FoblexNode.Place.BottomLeft:
                return {
                    x: baseNode.position.x - (dimension.width * NODES_BASE_LENGTH) - gap,
                    y: baseNode.position.y + baseNode.dimension.height * NODES_BASE_LENGTH + gap,
                };
            case FoblexNode.Place.BottomRight:
                return {
                    x: baseNode.position.x + (baseNode.dimension.width * NODES_BASE_LENGTH) + (2 * connectorWidth) + gap,
                    y: baseNode.position.y + baseNode.dimension.height * NODES_BASE_LENGTH + gap,
                };
            default:
                // Default to Top placement
                return {
                    x: baseNode.position.x + ((baseNode.dimension.width * NODES_BASE_LENGTH) + (2 * connectorWidth) - (dimension.width * NODES_BASE_LENGTH)) / 2,
                    y: baseNode.position.y - dimension.height * NODES_BASE_LENGTH - gap,
                };
        }
    }

    public reCalculatePosition () {
        this.position = this.calculatePosition();
    }
}

